(function () {
  'use strict';

  function visibleFocusable(root) {
    return Array.prototype.slice.call(root.querySelectorAll(
      'a[href],button:not([disabled]),input:not([disabled]):not([type="hidden"]),' +
      'select:not([disabled]),textarea:not([disabled]),summary,[tabindex]:not([tabindex="-1"])'
    )).filter(function (node) {
      return !node.hidden && node.getAttribute('aria-hidden') !== 'true' && node.offsetParent !== null;
    });
  }

  function initMenu(menu) {
    if (!menu || menu.dataset.moodA11yBound === 'true') return;
    var id = menu.id || 'mood-menu';
    menu.id = id;
    menu.dataset.moodA11yBound = 'true';
    menu.setAttribute('role', 'dialog');
    menu.setAttribute('aria-modal', 'true');
    if (!menu.getAttribute('aria-label')) menu.setAttribute('aria-label', 'תפריט ראשי');

    var button = document.querySelector('header button[aria-label="תפריט"]') ||
      document.querySelector('header .hactions button.ic');
    var close = menu.querySelector('.m-menu-close');
    if (!button || !close) return;
    button.setAttribute('aria-controls', id);
    button.setAttribute('aria-haspopup', 'dialog');
    button.setAttribute('aria-expanded', 'false');
    var returnFocus = button;

    function isOpen() {
      return menu.classList.contains('open') && menu.getAttribute('aria-hidden') !== 'true';
    }

    function openMenu(event) {
      if (event) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
      returnFocus = document.activeElement || button;
      menu.classList.add('open');
      menu.setAttribute('aria-hidden', 'false');
      button.setAttribute('aria-expanded', 'true');
      document.body.classList.add('m-open');
      close.focus();
    }

    function closeMenu(event, restore) {
      if (event) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
      menu.classList.remove('open');
      menu.setAttribute('aria-hidden', 'true');
      button.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('m-open');
      if (restore !== false && returnFocus && typeof returnFocus.focus === 'function') returnFocus.focus();
    }

    button.addEventListener('click', openMenu, true);
    close.addEventListener('click', function (event) { closeMenu(event, true); }, true);
    menu.addEventListener('click', function (event) {
      if (event.target === menu) closeMenu(event, true);
    }, true);
    menu.querySelectorAll('a[href]').forEach(function (link) {
      link.addEventListener('click', function () { closeMenu(null, false); }, true);
    });
    document.addEventListener('keydown', function (event) {
      if (!isOpen()) return;
      if (event.key === 'Escape') {
        closeMenu(event, true);
        return;
      }
      if (event.key !== 'Tab') return;
      var nodes = visibleFocusable(menu);
      if (!nodes.length) return;
      var first = nodes[0];
      var last = nodes[nodes.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }, true);
  }

  function initPurchaseSelector(root) {
    if (!root || root.dataset.moodA11yBound === 'true') return;
    var cards = Array.prototype.slice.call(root.querySelectorAll('.mood-ps-card'));
    if (!cards.length) return;
    root.dataset.moodA11yBound = 'true';
    var group = root.querySelector('.mood-ps-cards') || root;
    group.setAttribute('role', 'radiogroup');
    group.setAttribute('aria-label', 'בחירת חבילה');

    function sync() {
      var selected = cards.find(function (card) {
        var input = card.querySelector('input[type="radio"]');
        return card.classList.contains('selected') || Boolean(input && input.checked);
      }) || cards[0];
      cards.forEach(function (card) {
        var input = card.querySelector('input[type="radio"]');
        var checked = card === selected;
        card.removeAttribute('role');
        card.removeAttribute('aria-checked');
        card.removeAttribute('tabindex');
        if (input) {
          input.tabIndex = checked ? 0 : -1;
          input.removeAttribute('aria-hidden');
        }
      });
    }

    group.addEventListener('click', function () { queueMicrotask(sync); });
    group.addEventListener('keydown', function (event) {
      if (!/^Arrow(?:Left|Right|Up|Down)$/.test(event.key)) return;
      var current = event.target.closest && event.target.closest('.mood-ps-card');
      var index = cards.indexOf(current);
      if (index < 0) return;
      event.preventDefault();
      var forward = event.key === 'ArrowLeft' || event.key === 'ArrowDown';
      var next = cards[(index + (forward ? 1 : -1) + cards.length) % cards.length];
      next.click();
      queueMicrotask(function () {
        sync();
        var nextInput = next.querySelector('input[type="radio"]');
        if (nextInput) nextInput.focus();
      });
    });
    var observer = new MutationObserver(sync);
    cards.forEach(function (card) { observer.observe(card, { attributes: true, attributeFilter: ['class'] }); });
    sync();
  }

  function initSearchDialog(overlay, index) {
    if (!overlay || overlay.dataset.moodA11yBound === 'true') return;
    overlay.dataset.moodA11yBound = 'true';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', 'חיפוש באתר');
    overlay.setAttribute('aria-hidden', overlay.hidden ? 'true' : 'false');
    if (!overlay.id) overlay.id = 'mood-search-dialog-' + index;
    var opener = null;
    var triggers = Array.prototype.slice.call(document.querySelectorAll('header button[aria-label="חיפוש"]'));
    var close = overlay.querySelector('.mood-search-close');
    var label = overlay.querySelector('label');
    if (label) {
      if (!label.id) label.id = overlay.id + '-title';
      overlay.setAttribute('aria-labelledby', label.id);
      overlay.removeAttribute('aria-label');
    }
    function openDialog(event, button) {
      if (event) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
      opener = button || document.activeElement;
      overlay.hidden = false;
      document.body.classList.add('mood-search-open');
      syncState();
    }

    triggers.forEach(function (button) {
      button.setAttribute('aria-haspopup', 'dialog');
      button.setAttribute('aria-controls', overlay.id);
      button.setAttribute('aria-expanded', 'false');
      button.addEventListener('click', function (event) { openDialog(event, button); }, true);
    });

    function syncState() {
      var isOpen = !overlay.hidden;
      overlay.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
      triggers.forEach(function (button) { button.setAttribute('aria-expanded', isOpen ? 'true' : 'false'); });
      if (isOpen) {
        var target = overlay.querySelector('input,button,a[href]');
        if (target) requestAnimationFrame(function () { target.focus(); });
      } else if (opener && typeof opener.focus === 'function') {
        opener.focus();
      }
    }

    function closeDialog(event) {
      if (event) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
      if (overlay.hidden) return;
      overlay.hidden = true;
      document.body.classList.remove('mood-search-open');
      syncState();
    }
    var observer = new MutationObserver(function () {
      syncState();
    });
    observer.observe(overlay, { attributes: true, attributeFilter: ['hidden'] });
    if (close) close.addEventListener('click', closeDialog, true);
    overlay.addEventListener('click', function (event) {
      if (event.target === overlay) closeDialog(event);
    }, true);
    overlay.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closeDialog(event);
        return;
      }
      if (event.key !== 'Tab' || overlay.hidden) return;
      var nodes = visibleFocusable(overlay);
      if (!nodes.length) return;
      var first = nodes[0];
      var last = nodes[nodes.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
    syncState();
  }

  function improveDocumentSemantics() {
    document.querySelectorAll('[aria-live]').forEach(function (region) {
      if (!region.getAttribute('aria-atomic')) region.setAttribute('aria-atomic', 'true');
    });
    document.querySelectorAll('img:not([alt])').forEach(function (image) {
      image.setAttribute('alt', '');
    });
    document.querySelectorAll('a[target="_blank"]').forEach(function (link) {
      var rel = (link.getAttribute('rel') || '').split(/\s+/).filter(Boolean);
      if (rel.indexOf('noopener') < 0) rel.push('noopener');
      link.setAttribute('rel', rel.join(' '));
    });
  }

  document.querySelectorAll('.m-menu').forEach(initMenu);
  document.querySelectorAll('#mood-purchase-selector').forEach(initPurchaseSelector);
  document.querySelectorAll('.mood-search-overlay').forEach(initSearchDialog);
  improveDocumentSemantics();
})();
